/**
 * How often an open cabinet re-reads the account and its trading state. The
 * overview beside them refreshes every fifteen seconds; these did not refresh
 * at all, so a close changed the open figures and left «Заработано» and «Бот
 * торгует» where they were (audit, 2026-10-16).
 */
export const ACCOUNT_REFRESH_MS = 15_000;
